import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { ICompanyMast } from "../../models/CompanyMast";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { ICityMastDropdown, IClientCompanyDropdown, IStateMastDropdown } from "../../models/IDropdown";
import { JVDate } from "../../shared/JVDate";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { ICompanyAuthorizedSignatory } from "../companyMast/CompanyAuthorizedSignatory";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { JVInputMask } from "../../shared/JVInputMask";
import { ISpecialClauseMast } from "../specialClauseMast/Form";
interface IProps {
  singleData: any;
  open: boolean;
  hideDialog: () => void;
  toast: any;
}

export interface IGeneratePo {
  id?: number;
  company_Name_Sales?: ICompany;
  sub_Vendor_Company?: IClientCompanyDropdown;
  pO_Date: Date | null;
  consultant_Name: string;
  consultant_ID?: number;
  pO_ID?: number;
  end_Client_Name: string;
  remote: boolean;
  state_Name1?: string;
  state_Name?: {
    state_ID: number;
    state_Name: string;
  };
  city_Name?: {
    city_ID: number;
    city_Name: string;
  };

  project_Start_Date: Date | null;
  project_Duration: string;
  billing_Rate: number;
  prime_Vendor_Billing_Cycle: string;
  prime_Vendor_Payment_Term: string;
  termination_Notice: string;
  signatory_Name: string;
  signatory_Designation: string;
  company_Address?: string;
  feid?: string;
  position_Title?: string;
  req_ID?: number;
  tax_Term?: string;
  clause?: string;
  is_Special_Clasue?: boolean;
  special_Clause?: string;
  remoteType?: string;
  subVendor_signatory_Name: string;
  subVendor_signatory_Designation: string;
  subVendor_feid?: string;
  subVendor_Address?: string;
}

interface ICompany {
  company_ID?: number;
  company_Name?: string;
}
const schema = yup.object().shape({
  company_Name_Sales: yup
    .object({
      company_ID: yup.number(),
      company_Name: yup.string(),
    })
    .required("Company Name Sales is required"),
  sub_Vendor_Company: yup
    .object({
      client_ID: yup.number(),
      client_Name: yup.string(),
    })
    .required("Sub vendor Company Name is required"),
  // pO_Date: yup.date().nullable(true).required('PO Date is required'),
  consultant_Name: yup.string().required("Consultant Name is required"),
  end_Client_Name: yup.string().required("End Client Name is required"),
  remote: yup.boolean().nullable(),
  state_Name: yup.object().when("remote", (val) => {
    return val === true
      ? yup.object().nullable()
      : yup.object().shape({
        state_ID: yup.number().required("State ID is required"),
        state_Name: yup.string().required("State Name is required"),
      });
  }),
  city_Name: yup.object().when("remote", (val) => {
    return val === true
      ? yup.object().nullable()
      : yup.object().shape({
        city_ID: yup.number().required("City ID is required"),
        city_Name: yup.string().required("City Name is required"),
      });
  }),

  project_Start_Date: yup.date().nullable(true).required("Project Start Date is required"),
  project_Duration: yup.string().required("Project Duration is required"),
  billing_Rate: yup.number().required("Billing Rate is required").min(0, "Billing Rate must be a positive value"),
  prime_Vendor_Billing_Cycle: yup.string().required("Billing Cycle is required"),
  prime_Vendor_Payment_Term: yup.string().required("Payment Term is required"),
  termination_Notice: yup.string().required("Termination Notice is required"),
  signatory_Name: yup.string().required("Signatory Name is required"),
  signatory_Designation: yup.string().required("Signatory Designation is required"),
  feid: yup.string().required("FEID is required"),
  subVendor_feid: yup.string().required("Designation FEID is required"),
  subVendor_signatory_Designation: yup.string().required("Sub Vendor Signatory Designation is required"),
  subVendor_signatory_Name: yup.string().required("Sub Vendor Signatory Name is required"),
  subVendor_Address: yup.string().required("Sub Vendor Address  is required"),
  position_Title: yup.string().required("Position Title is required"),
  is_Special_Clasue: yup.boolean().nullable(),
  special_Clause: yup.string().when("is_Special_Clasue", (val) => {
    return val === true ? yup.string().required("Special Clause Name required") : yup.string().nullable();
  }),
});

const termination_Notice = [{ name: "15 Days" }, { name: "21 Days" }, { name: "30 Days" }];
const billingCycle = [{ name: "Weekly" }, { name: "Monthly" }, { name: "Bi-Weekly" }];
const Payment_Term = [{ name: "Net 30" }, { name: "Net 45" }, { name: "Pay on Pay" }, { name: "Net 15" }, { name: "Net 60" }, { name: "Net 7" }];

const sanitizeFormData = (data: any): IGeneratePo => {
  const {
    company_Name_Sales,
    sub_Vendor_Company,
    pO_Date,
    consultant_Name,
    end_Client_Name,
    remote,
    state_Name,
    city_Name,
    project_Start_Date,
    project_Duration,
    billing_Rate,
    prime_Vendor_Billing_Cycle,
    prime_Vendor_Payment_Term,
    termination_Notice,
    signatory_Name,
    signatory_Designation,
    company_Address,
    feid,
    position_Title,
    consultant_ID,
    pO_ID,
    req_ID,
    tax_Term,
    subVendor_feid,
    subVendor_signatory_Designation,
    subVendor_signatory_Name,
    subVendor_Address,
  } = data;

  return {
    company_Name_Sales,
    sub_Vendor_Company,
    pO_Date,
    consultant_Name,
    end_Client_Name,
    remote,
    state_Name,
    city_Name,
    project_Start_Date,
    project_Duration,
    billing_Rate,
    prime_Vendor_Billing_Cycle,
    prime_Vendor_Payment_Term,
    termination_Notice,
    signatory_Name,
    signatory_Designation,
    company_Address,
    feid,
    position_Title,
    consultant_ID,
    pO_ID,
    req_ID,
    tax_Term,
    subVendor_feid,
    subVendor_signatory_Designation,
    subVendor_signatory_Name,
    subVendor_Address,
  };
};

export const GeneratePO = (props: IProps) => {
  const [company, setCompany] = useState<ICompany[]>([]);
  const [subVendorCompanies, setsubVendorCompanies] = useState<Array<IClientCompanyDropdown>>();
  const [states, setStates] = useState<Array<IStateMastDropdown>>();
  const [cities, setCities] = useState<Array<ICityMastDropdown>>();
  const [signatory, setSignatory] = useState<ICompanyAuthorizedSignatory[]>([]);
  const [companyDetail, setCompanyDetail] = useState<ICompanyMast[]>([]);
  const [clause, setClause] = useState("");
  const [specialClause, setSpecialClause] = useState<ISpecialClauseMast[]>([]);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm<IGeneratePo>({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props.singleData,
      project_Start_Date: props.singleData?.project_Start_Date ? new Date(props.singleData.project_Start_Date) : new Date(),
      pO_Date: props.singleData?.pO_Date ? new Date(props.singleData.pO_Date) : new Date(),
      company_Name_Sales: {
        company_ID: props.singleData?.company_ID_Sales,
        company_Name: props.singleData?.company_Name_Sales,
      },
      sub_Vendor_Company: {
        vendor_Company_ID: props.singleData?.sub_Vendor_ID,
        vendor_Company_Name: props.singleData?.sub_Vendor_Company,
      },
      state_Name: {
        state_ID: props.singleData?.state_ID || 0,
        state_Name: props.singleData?.state_Name || "",
      },
      city_Name: {
        city_ID: props.singleData?.city_ID || 0,
        city_Name: props.singleData?.city_Name || "",
      },
      billing_Rate: props.singleData?.sRate,
      project_Duration: props.singleData?.req_Duration,
      end_Client_Name: props.singleData?.project_Client_Name,
      position_Title: props.singleData?.project_Name,
      remote: props.singleData?.job_Type === "Remote" ? true : false,
      //  pO_ID:props.singleData?.pO_ID
    },
    shouldFocusError: false,
  });
  const isRemote = watch("remote");
  const selectedSignatoryName = watch("signatory_Name");
  const special_Constraint = watch("is_Special_Clasue");

  useEffect(() => {
    reset({
      ...props.singleData,
      project_Start_Date: props.singleData?.project_Start_Date ? new Date(props.singleData.project_Start_Date) : new Date(),
      //  pO_Date: props.singleData?.pO_Date ? new Date(props.singleData.pO_Date) : new Date(),
      pO_Date: new Date(),
      company_Name_Sales: {
        company_ID: props.singleData?.company_ID_Sales,
        company_Name: props.singleData?.company_Name_Sales,
      },
      sub_Vendor_Company: {
        vendor_Company_ID: props.singleData?.sub_Vendor_ID,
        vendor_Company_Name: props.singleData?.sub_Vendor_Company,
      },
      state_Name: {
        state_ID: props.singleData?.state_ID || 0,
        state_Name: props.singleData?.state_Name || "",
      },
      city_Name: {
        city_ID: props.singleData?.city_ID || 0,
        city_Name: props.singleData?.city_Name || "",
      },
      billing_Rate: props.singleData?.bRate,
      project_Duration: props.singleData?.req_Duration,
      end_Client_Name: props.singleData?.project_Client_Name,
      position_Title: props.singleData?.project_Name,
      remote: props.singleData?.job_Type === "Remote" ? true : false,

      //    pO_ID:props.singleData?.pO_ID
    });
  }, [props.singleData]);

  useEffect(() => {
    const selectedSignatory = signatory.find((s) => s.name === selectedSignatoryName);
    if (selectedSignatory) {
      setValue("signatory_Designation", selectedSignatory.designation || "");
    }
  }, [selectedSignatoryName, signatory, setValue]);

  const loadCompanies = async (filter: string | null) => {
    const response = await Fetch("Dropdown/getCompany", "GET", null, `filter=${filter}`, null);
    if (response) {
      const data: Array<ICompany> = await response.json();
      setCompany(data);
    }
  };
  const completeMethodCompanies = (event: { query: string }) => {
    loadCompanies(event.query);
  };

  const loadsubClientCompanies = async (filter: string | null) => {
    const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
    if (response) {
      const data: Array<IClientCompanyDropdown> = await response.json();
      setsubVendorCompanies(data);
    }
  };
  const completeMethodSubVendor = (event: { query: string }) => {
    loadsubClientCompanies(event.query);
  };
  const loadStates = async (filter: string | null) => {
    const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
    if (response) {
      const data: Array<IStateMastDropdown> = await response.json();
      setStates(data);
    }
  };
  const completeMethodStates = (event: { query: string }) => {
    loadStates(event.query);
  };

  const loadCities = async (filter: string | null) => {
    if (control._formValues.state_Name?.state_ID) {
      const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state_Name.state_ID}`, null);
      if (response) {
        const data: Array<ICityMastDropdown> = await response.json();
        setCities(data);
      }
    } else {
      props.toast.current?.show({ severity: "error", detail: "Select the State First.", life: 3000 });
    }
  };
  const completeMethodCities = (event: { query: string }) => {
    loadCities(event.query);
  };

  const getSignatory = async () => {
    const response = await Fetch("Company_Mast/getSignature", "GET", null, `comp_Id=${props.singleData.company_ID_Sales}`, null);
    if (response) {
      const data = await response.json();
      setSignatory(data);
    }
  };

  const loadCompanyLogo = async () => {
    const response = await Fetch("Company_Mast/getCompanyLogo", "GET", null, `comp_id=${props.singleData.company_ID_Sales}`, null);
    if (response) {
      const data: Array<any> = await response.json();
      setCompanyDetail(data);
    }
  };

  const loadSpecialClause = async () => {
    const response = await Fetch("DropDown/getSpecialClause", "GET", null, null, props.toast);
    if (response) {
      const data = await response.json();
      setSpecialClause(data);
    }
  };

  // this is use for show image in pdf
  const signature = signatory.find((signatory) => signatory.signature);
  const signatureBase64 = `data:image/png;base64,${signature?.signature}`;

  const companyLogo = companyDetail.find((companyDetail) => companyDetail.company_Logo);
  const companyLogoBase64 = `data:image/png;base64,${companyLogo?.company_Logo}`;

  useEffect(() => {
    if (companyLogo?.feid) {
      setValue("feid", companyLogo?.feid || "");
    }
  }, [companyLogo?.feid]);

  const onSubmit = async (data: any) => {
    data.clause = clause;
    var htmlClauseString = data.clause;
    var plainClauseString = htmlClauseString
      // .replace(/<br\s*\/?>/gi, '\n') // Replace <br> with \n
      .replace(/<\/div>/gi, "\n") // Add line break at the end of </div>
      .replace(/<[^>]+>/g, ""); // Remove all other HTML tags // this is use to convert html into plain string
    var Clause = plainClauseString.replace(/&nbsp;/g, " ").trim();
    console.log("Clause:-", Clause);
    console.log("plainClauseString:-", plainClauseString);
    console.log("htmlClauseString:-", htmlClauseString);

    const cityName = data?.city_Name?.city_Name;
    const stateName = data?.state_Name?.state_Name;
    data.city_Name = data.city_Name ? data.city_Name?.city_ID : data.city_Name;
    data.state_Name = data.state_Name ? data.state_Name?.state_ID : data.state_Name;
    data.sub_Vendor_Company = data.sub_Vendor_Company?.vendor_Company_Name;

    if (data.is_Special_Clasue === null || data.is_Special_Clasue === false) {
      delete data.clause;
      delete data.special_Clause;
      Clause = null;
    }

    const sanitizedData = sanitizeFormData(data);
    sanitizedData.company_Address = companyLogo?.company_Address;
    // const response = await Fetch("vwPODetails/updateGeneratePo", "PUT", sanitizedData, null, props.toast);
    // if (response) {
    //   props.toast.current?.show({ severity: "success", detail: "Purchase Order Updated Successfully.", life: 3000 });
    // }
    onHide();
    const companyLogoImage = companyLogoBase64 || ""; // Fallback to empty if undefined
    const signatureImage = signatureBase64 || ""; // Fallback to empty if undefined
    // console.log(signatureBase64);
    // let logoImage;
    // if(signature?.signature==undefined){
    //     logoImage=`text: ''`;
    // }else{
    //     logoImage=`image: signatureBase64`;

    // }

    pdfMake.vfs = pdfFonts.vfs;

    const billingCycle = data?.prime_Vendor_Billing_Cycle || "";
    const days = data.prime_Vendor_Payment_Term !== undefined && data.prime_Vendor_Payment_Term !== null ? (data.prime_Vendor_Payment_Term.trim() === "Pay on Pay" ? data.prime_Vendor_Payment_Term : data.prime_Vendor_Payment_Term.trim().split(" ")[1] + "days") : "";

    const docDefinition: TDocumentDefinitions = {
      content: [
        companyLogo?.company_Logo !== undefined || null ? { image: companyLogoBase64, fit: [100, 100], alignment: "center", margin: [0, -30, 0, 0] } : { text: "", margin: [0, -30, 0, 0] }, // Fallback for missing image
        { text: "Purchase Order", style: "header", alignment: "center" },
        { text: `This Statement of Work is executed between ${sanitizedData.company_Name_Sales?.company_Name} and ${sanitizedData.sub_Vendor_Company} on Dated ${sanitizedData.pO_Date?.toLocaleDateString("en-US")}.`, style: "subheader", margin: [0, 10, 0, 20] },
        {
          text: "Description of Assignment:",
          style: "sectionHeader",
          fillColor: "#eeeeee",
          alignment: "center",
        },
        {
          table: {
            widths: ["30%", "70%"],
            body: [
              [
                { text: "Consultant Name", style: "titleInTable" },
                { text: `${sanitizedData.consultant_Name}`, style: "descInTable" },
              ],
              [
                { text: "Client Name / Location", style: "titleInTable" },
                { text: `${sanitizedData.end_Client_Name} / ${data.remote === true ? "Remote" : cityName}, ${stateName ? stateName : ""}`, style: "descInTable" },
              ],
              [
                { text: "Position Title", style: "titleInTable" },
                { text: data?.position_Title, style: "descInTable" },
              ],
              [
                { text: "Project Start Date", style: "titleInTable" },
                { text: sanitizedData.project_Start_Date?.toLocaleDateString() || "", style: "descInTable" },
              ],
              [
                { text: "Duration", style: "titleInTable" },
                { text: `${sanitizedData.project_Duration} `, style: "descInTable" },
              ],
              [
                { text: "Billing Rate", style: "titleInTable" },
                { text: `$${sanitizedData.billing_Rate}/hr. ${sanitizedData.tax_Term}`, style: "descInTable" },
              ],
              [
                { text: "Invoicing and Payment:", style: "titleInTable" },
                {
                  text: `Payment to the CONTRACTOR will be due ${days} from invoice date. Billing cycle for invoicing shall be ${billingCycle} and invoices must be submitted along with End-Client authorized and approved timesheets. The CONTRACTOR/CONSULTANT will submit weekly approved Time-sheets ${"to " + companyDetail[0]?.accounts_Email || ""}. If applicable, BGC cost will be deducted from the first-month contractor invoice.`,
                  colSpan: 1,
                  margin: [10, 5, 0, 0],
                  style: "descInTable",
                },
              ],
              [
                { text: "Termination:", style: "titleInTable" },
                {
                  text: `CONTRACTOR/CONSULTANT must give ${sanitizedData.termination_Notice} written notice to ${sanitizedData.company_Name_Sales?.company_Name}’s client / End Client. ${sanitizedData.company_Name_Sales?.company_Name} must be informed in such events. If the candidate didn’t provide ${sanitizedData.termination_Notice} of notice, ${sanitizedData.company_Name_Sales?.company_Name}is only liable to provide the amount received by the client and in case of nonpayment we will provide sufficient proof.`,
                  colSpan: 1,
                  margin: [10, 5, 0, 0],
                  style: "descInTable",
                },
              ],
              ...(Clause && Clause !== null
                ? [
                  [
                    { text: `${data.special_Clause}`, style: "titleInTable" },
                    { text: `${Clause}`, colSpan: 1, margin: [10, 5, 0, 0], style: "descInTable" },
                  ],
                ]
                : []),
            ],
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => "#000000",
            vLineColor: () => "#000000",
          },
          margin: [0, 0, 0, 20],
        },
        {
          text: [
            { text: "Acceptance:", style: "sectionHeader" },
            { text: "Authorized representatives of both parties have executed this Statement of Work and express the agreement to its terms.", margin: [0, 10, 0, 20] },
          ],
          margin: [0, 10, 0, 20],
        },
        {
          table: {
            widths: ["15%", "35%", "15%", "35%"],
            headerRows: 2,
            body: [
              [{ text: `${sanitizedData.company_Name_Sales?.company_Name} \n ${sanitizedData.company_Address ? sanitizedData.company_Address : ""}`, style: "boldText", colSpan: 2 }, {}, { text: `${sanitizedData.sub_Vendor_Company} \n ${sanitizedData.subVendor_Address ? sanitizedData.subVendor_Address : ""}`, style: "boldText", colSpan: 2 }, {}],
              //[{ text: 'Signature:', style: 'titleInTable', }, {image: signatureBase64, width: 150, height: 30, }, { text: 'Signature:', style: 'titleInTable' }, { text: '' }],
              [{ text: "Signature:", style: "titleInTable" }, signature?.signature != undefined || null ? { image: signatureImage, width: 150, height: 30 } : { text: "" }, { text: "Signature:", style: "titleInTable" }, { text: "" }],
              [
                { text: "Name:", style: "titleInTable" },
                { text: `${sanitizedData.signatory_Name}`, style: "titleInTable" },
                { text: "Name:", style: "titleInTable" },
                { text: `${sanitizedData.subVendor_signatory_Name}`, style: "titleInTable" },
              ],
              [
                { text: "Title:", style: "titleInTable" },
                { text: `${sanitizedData.signatory_Designation}`, style: "titleInTable" },
                { text: "Title: ", style: "titleInTable" },
                { text: `${sanitizedData.subVendor_signatory_Designation}`, style: "titleInTable" },
              ],
              [
                { text: "FEID#:", style: "titleInTable" },
                { text: `${sanitizedData.feid}`, style: "titleInTable" },
                { text: "FEID#:", style: "titleInTable" },
                { text: `${sanitizedData.subVendor_feid}`, style: "titleInTable" },
              ],
            ],
          },
        },
      ],
      styles: {
        header: { fontSize: 14, bold: true },
        subheader: { fontSize: 12, italics: true },
        sectionHeader: { fontSize: 12, bold: true, margin: [10, 10, 0, 10] },
        titleInTable: { fontSize: 12, bold: true, fillColor: "#eeeeee", margin: [7, 0, 0, 0] },
        descInTable: { fontSize: 11, margin: [7, 0, 0, 0] },
        boldText: { bold: true },
      },
    };
    pdfMake.createPdf(docDefinition).download(`purchase_order.pdf`);
    // pdfMake.createPdf(docDefinition).open();
  };

  const onHide = () => {
    props.hideDialog();
    setClause("");
  };

  useEffect(() => {
    if (props.open === true) {
      getSignatory();
      loadCompanyLogo();
      loadSpecialClause();
    }
  }, [props.open]);

  return (
    <Dialog visible={props.open} style={{ width: "80vw" }} header="Add/Update Generate PO" className="p-fluid" onHide={onHide}>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <JVDropdownInput disabled column={3} required completeMethod={completeMethodCompanies} label="Company" control={control} name="company_Name_Sales" options={company} error={errors.company_Name_Sales?.company_Name?.message} optionLabel="company_Name" placeholder="Search Company" />
        <JVDropdownInput
          column={3}
          required
          label="Sub Vendor"
          completeMethod={completeMethodSubVendor}
          control={control}
          name="sub_Vendor_Company"
          disabled
          options={subVendorCompanies}
          error={errors.sub_Vendor_Company?.vendor_Company_Name?.message}
          optionLabel="vendor_Company_Name"
          placeholder="Search Sub Vendor"
        />
        {/* <JVDate column={4} required name='pO_Date' label='Date Of PO' control={control} error={errors.pO_Date?.message} /> */}
        <JVInput column={3} required label="Consultant Name" control={control} name="consultant_Name" error={errors.consultant_Name?.message} />
        <JVInput column={4} required label="End Client Name" control={control} name="end_Client_Name" error={errors.end_Client_Name?.message} />
        <div className=" field col-6 md:col-3 mt-4">
          <p style={{ color: "white" }}></p>
          <JVCheckbox column={3} name="remote" label="Remote" control={control} error={errors.remote?.message} />
        </div>
        <JVDropdownInput required column={4} disabled={isRemote} completeMethod={completeMethodStates} label="State" control={control} name="state_Name" error={errors.state_Name?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
        <JVDropdownInput required column={4} disabled={isRemote} completeMethod={completeMethodCities} label="City" control={control} name="city_Name" error={errors.city_Name?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
        <JVInput column={4} required label="Project Title" control={control} name="position_Title" error={errors.position_Title?.message} />
        <JVDate column={4} required name="project_Start_Date" label="Project Start Date" control={control} error={errors.project_Start_Date?.message} />
        <JVInput column={4} required label="Project Duration" control={control} name="project_Duration" error={errors.project_Duration?.message} />
        <JVInput column={4} disabled required label="Billing Rate" control={control} name="billing_Rate" error={errors.billing_Rate?.message} />
        <JVDropdown column={4} required label="Billing Cycle" control={control} name="prime_Vendor_Billing_Cycle" options={billingCycle} optionLabel="name" optionValue="name" placeholder="-- Select Termination Notice" error={errors.prime_Vendor_Billing_Cycle?.message} />
        <JVDropdown column={4} label="Payment Term" control={control} name="prime_Vendor_Payment_Term" options={Payment_Term} optionLabel="name" optionValue="name" placeholder="Select Payment Term" error={errors.prime_Vendor_Payment_Term?.message} />
        <JVDropdown column={4} required label="Termination Notice" control={control} name="termination_Notice" options={termination_Notice} optionLabel="name" optionValue="name" placeholder="-- Select Termination Notice" error={errors.termination_Notice?.message} />
        <JVDropdown column={4} required label="Signatory Name" name="signatory_Name" control={control} options={signatory} optionLabel="name" optionValue="name" placeholder="-- Select Signatory--" error={errors.signatory_Name?.message} />
        <JVInput column={4} required label="Signatory Designation" control={control} name="signatory_Designation" error={errors.signatory_Designation?.message} />
        <JVInputMask column={4} required mask="99-9999999" label="FEID" control={control} name="feid" error={errors.feid?.message} />
        <JVInput column={4} required label="Sub Vendor Signatory Name" control={control} name="subVendor_signatory_Name" error={errors.subVendor_signatory_Name?.message} />
        <JVInput column={4} required label="Sub Vendor Signatory Designation" control={control} name="subVendor_signatory_Designation" error={errors.subVendor_signatory_Designation?.message} />
        <JVInputMask column={4} required mask="99-9999999" label="Sub Vendor FEID" control={control} name="subVendor_feid" error={errors.subVendor_feid?.message} />
        <JVInput column={4} required label="Sub Vendor Address " control={control} name="subVendor_Address" error={errors.subVendor_Address?.message} />
        <div className="field col-6 md:col-3 mt-4">
          <JVCheckbox column={4} label="Special Clause" name="is_Special_Clasue" control={control} />
        </div>
        {special_Constraint === true && <JVDropdown required={true} column={4} label="Special Clause" name="special_Clause" control={control} options={specialClause} optionLabel="special_Clause" optionValue="special_Clause" error={errors.special_Clause?.message} />}
        {special_Constraint === true && <JVSunEditor value={clause} handleChange={setClause} />}

        <div className="col-12 md:col-12 flex gap-4">
          <Button className="field col md:col" label="Generate PO" type="submit"></Button>
          <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
        </div>
      </form>
    </Dialog>
  );
};
